// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2C37u","content":"Consent_content__2CXhZ","footer":"Consent_footer__2c_ph"};